import _taggedTemplateLiteral from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { useLayer } from './hooks';
import { LayerProvider } from './provider';
var Root = styled.div(_templateObject());
export var Layer = forwardRef(function (_a, ref) {
  var depth = _a.depth,
      restProps = __rest(_a, ["depth"]);

  return React.createElement(LayerProvider, {
    baseDepth: depth,
    id: restProps.id
  }, React.createElement(LayerChildren, Object.assign({}, restProps, {
    ref: ref
  })));
});
Layer.displayName = 'Layer';
var LayerChildren = forwardRef(function (_a, ref) {
  var children = _a.children,
      _a$style = _a.style,
      style = _a$style === void 0 ? {} : _a$style,
      restProps = __rest(_a, ["children", "style"]);

  var layer = useLayer() || {
    depth: 0
  };
  return React.createElement(Root, Object.assign({
    "data-ui": "Layer"
  }, restProps, {
    ref: ref,
    style: Object.assign(Object.assign({}, style), {
      zIndex: layer.depth
    })
  }), children);
});
LayerChildren.displayName = 'LayerChildren';